import { REQ_PROFILE, SET_PROFILE, REQ_PROFILE_DONE } from "../../utils/constants/actionTypes";

const initialState = {
	list: null,
	isLoading: false,
	errorMessage: "",
};

export default (state = initialState, action) => {
	switch (action.type) {
		case REQ_PROFILE:
			return {
				...state,
				isLoading: true,
			};
		case REQ_PROFILE_DONE:
			return {
				...state,
				isLoading: false,
			};
		case SET_PROFILE:
			return {
				list: action.payload,
				isLoading: false,
				errorMessage: "",
			};
		default:
			return state;
	}
};
